<template>
  <div class="card companyProfileDocumentsLayout" style="margin-bottom:15px;">
    <div class="companyProfileDocumentsHeader" style>
      <div class="row" style="margin: 0;">
        <div class="flex-grow-1 companyProfileTabulatorTitle">Documents</div>
        <div
          class="d-flex companyProfileCardsAddButton"
          @click="showAddModal"
          v-if="showAddDocumnets"
        >
          <div>
            <i class="fa fa-plus" style="font-size: 8px;"></i>
          </div>
          <div>Add</div>
        </div>
      </div>
      <div class="companyProfileTabulatorTitleBorderLine" style="margin-bottom:5px"></div>
    </div>
    <div
      class="notesCardBodyLayout style-3"
      id="style-3"
      style="padding-left:20px;padding-right:20px"
    >
      <div
        class="row notesCardBodyParent"
        style="margin: 0;"
        v-for="(item,index) in data.attachments"
        :key="index"
      >
        <!-- <div class="d-flex w-100"> -->
        <div class="col-12 pl-0 pr-0">
          <div class="d-flex">
            <div class="col-11 pl-0 pr-0">
              <div class="col-12 pl-0 pr-0 notesCardBodyNameAndDateColParent">
                <span
                  class="documentsName"
                  :style="showDownloadDocumnets ? 'cursor:pointer;' : 'cursor:default'"
                  v-if="item.link_type == 'File'"
                  @click="download(item)"
                >{{item.name}}</span>
                <span
                  :class="showDownloadDocumnets?'documentsName documentsLinkPortfolio':'documentsName'"
                  :style="showDownloadDocumnets ? 'color: #5445F3;cursor:pointer' : 'cursor:default'"
                  v-else
                  @click="download(item)"
                >{{item.url}}</span>
                <span
                  class="documentsCardDate"
                  style="cursor:default"
                >, on {{new Date(item.date).getDate()}} {{monthArray[new Date(item.date).getMonth()]}} {{new Date(item.date).getFullYear()}}</span>
              </div>
              <div class="col-12 pl-0 pr-0">
                <div class="documentsCardNotes" v-if="item.notes">{{item.notes}}</div>
                <!-- <div class="companyProfileTabulatorTitleBorderLine"></div> -->
              </div>
            </div>
            <div class="col-1 pl-0 pr-0">
              <div
                class="ellipsesDropdownLayout"
                v-if="showShareDocumnets || showDownloadDocumnets || showAddDocumnets || showDeleteDocumnets"
              >
                <b-dropdown
                  size="sm"
                  variant
                  right
                  class="company-card-dropdown"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content style="border:0;background:none;">
                    <i class="fa fa-ellipsis-h" aria-hidden="true" style="color:#00000080"></i>
                  </template>
                  <b-dropdown-item
                    v-if="item.link_type == 'File'&& showDownloadDocumnets"
                    @click="download(item)"
                  >Download</b-dropdown-item>
                  <b-dropdown-item
                    v-if="item.link_type != 'File'&& showDownloadDocumnets"
                    @click="download(item)"
                  >Open Link</b-dropdown-item>
                  <b-dropdown-item
                    v-if="item.link_type == 'File' && showShareDocumnets"
                    @click="shareDocument(item)"
                  >Share</b-dropdown-item>
                  <b-dropdown-item @click="handleEditDocument(item)" v-if="showAddDocumnets">Edit</b-dropdown-item>
                  <b-dropdown-item
                    @click="deleteFlag=true;deleteData=item"
                    v-if="showDeleteDocumnets"
                  >Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div
            class="companyProfileTabulatorTitleBorderLine"
            style="margin-top:10px;margin-bottom:10px;cursor:default"
          ></div>
        </div>
       
      </div>
    </div>
    
    <a class="hidden" ref="hiddenDownloadLink" :href="downloadLink" target="_blank">Download Sample</a>
    <el-dialog
      center
      title="Delete Document"
      width="400px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="deleteFlag"
      @close="handleCancelDeleteDocument"
    >
      <div class="row" style="padding-left:15px;padding-right:15px">
        <div style="padding-left:30px;">Are you sure you want delete the Document?</div>
      </div>
      <div class="col-12 d-flex">
        <div class="col-xl edit-company-action-button-row" style="padding-right: 25px;">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteDocument"
            :disabled="showDeleteSpinner"
          >Cancel</button>
          <button
            type="submit"
            @click.prevent="handleDeleteDocument(deleteData)"
            class="todo-form-submit-button btn btn-primary"
            style="height:35px;"
            :disabled="showDeleteSpinner"
          >
            Delete
            <b-spinner v-if="showDeleteSpinner" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <EditDocumentsCard
      ref="editDocumentsCard"
      v-if="isEdit"
      :data="editProps.data"
      :portfolioItem="editProps.portfolioItem"
      :context="editProps.context"
      :isUpdate="{isShow:editProps.isUpdate}"
      @refresh="refreshDocuments"
      v-model="editProps"
    ></EditDocumentsCard>
    <addDocumentsCard
      v-if="addFlag"
      v-model="addProps.value"
      :portfolioItem="addProps.portfolioItem"
      context="companyProfile"
      @refresh="refreshAddDocuments"
    ></addDocumentsCard>
    <shareDocument v-model="shareProps" v-if="shareFlag"></shareDocument>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../src/axios_api";
//import { Company, patchCompany } from "../../../models/Company";
//import { vals } from "../../../util";
import { mapGetters } from "vuex";
import { vals } from "../../util";
import EditDocument from "../../pages/Dashboard/Dialogs/EditDocument";
import AddDocument from "../../pages/Dashboard/Dialogs/AddDocument";
import ShareDocument from "../../pages/Dashboard/Dialogs/ShareDocument";
export default {
  name: "documentsCard",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [EditDocument.name]: EditDocument,
    [AddDocument.name]: AddDocument,
    [ShareDocument.name]: ShareDocument,
  },
  props: {
    data: {},
    portfolioItem: Object,
    context: String,
    editData: {},
    isUpdate: Boolean,
  },
  data() {
    return {
      showSpinner: false,
      monthArray: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      addFlag: false,
      files: {
        add: [],
        update: [],
        delete: [],
        documentType: [],
      },
      url: {
        add: [],
        update: [],
        delete: [],
      },
      typeUrlCheck: false,
      urlValue: "",
      downloadLink: "",
      modalData: {},
      isCompanyDisabled: false,
      vals,
      documentTypeUrlAdd: [],
      documentTypeUrlEdit: [],
      deleteFlag: false,
      deleteData: {},
      showDeleteSpinner: false,
      isEdit: false,
      editProps: {},
      addProps: {},
      shareProps: {},
      shareFlag: false,
    };
  },
  computed: {
    ...mapGetters("portfolio", ["portfolioAll"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    moment() {
      return moment;
    },
    showAddDocumnets() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD DOCUMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDeleteDocumnets() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "DELETE DOCUMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showDownloadDocumnets() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "DOWNLOAD DOCUMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showShareDocumnets() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHARE DOCUMENT") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  methods: {
    formatUrl(url) {
      // make sure it starts w/ http(s)
      if (url.length > 1) {
        if (!url.startsWith("https")) url = "https://" + url;
        return url;
      } else return "";
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach((f) => {
        this.files.add.push(f);
      });
    },
    // handleCancelAddDocument() {
    //   this.addFlag = false;
    //   this.files = {
    //     add: [],
    //     update: [],
    //     delete: [],
    //     documentType: []
    //   };
    //   this.url = {
    //     add: [],
    //     update: [],
    //     delete: []
    //   };
    //   this.urlValue = "";
    //   this.typeUrlCheck = false;
    //   this.showSpinner = false;
    //   this.modalData = {};
    //   this.documentTypeUrlAdd = [];
    //   this.documentTypeUrlEdit = [];
    //   this.isEdit = false;
    //   this.isCompanyDisabled = false;
    // },
    saveFiles() {
      this.showSpinner = true;
      let self = this;

      let filePayload = {
        files: [],
        data: [],
      };
      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      // _.forEach(this.files.add, item => {
      //   if (item) {
      //     filePayload.files.push(item);
      //     filePayload.data.push({
      //       _id: item._id,
      //       name: item.name,
      //       collection_name: "portfolio",
      //       document_id: this.portfolioItem._id,
      //       portfolio_item: this.portfolioItem,
      //       link_type: "File"
      //     });
      //   }
      // });
      this.files.add.map((item, index) => {
        if (item) {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: this.portfolioItem._id,
            portfolio_item: this.portfolioItem,
            link_type: "File",
            date: this.modalData.date ? this.modalData.date : new Date(),
            notes: this.modalData.notes ? this.modalData.notes : "",
            document_type: this.files.documentType[index]
              ? this.files.documentType[index]
              : "",
          });
        }
      });
      // _.forEach(self.url.add, item => {
      //   if (item) {
      //     filePayload.files.push(null);
      //     filePayload.data.push({
      //       _id: item._id,
      //       name: item.name,
      //       collection_name: "portfolio",
      //       document_id: this.portfolioItem._id,
      //       portfolio_item: this.portfolioItem,
      //       link_type: "URL",
      //       url: item
      //     });
      //   }
      // });
      self.url.add.map((item, index) => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "portfolio",
            document_id: this.portfolioItem._id,
            portfolio_item: this.portfolioItem,
            link_type: "URL",
            url: item,
            date: this.modalData.date ? this.modalData.date : new Date(),
            notes: this.modalData.notes ? this.modalData.notes : "",
            document_type: this.documentTypeUrlAdd[index]
              ? this.documentTypeUrlAdd[index]
              : "",
          });
        }
      });
      self.$store.dispatch("file/createFile", filePayload).then(
        (item) => {
          self.$store.dispatch("file/getFile").then((res) => {
            self.data.attachments = self.$store.getters[
              "file/filesByPortfloioId"
            ](self.portfolioItem._id);
            self.handleCancelAddDocument();
            if (
              item.data.encrypt.limitExceededMessage &&
              item.data.encrypt.limitExceededMessage.length > 0 &&
              item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
            ) {
              self.$toaster.error(
                "Storage limit exceeded. Upgrade your plan to add more"
              );
            } else {
              self.$toaster.success("Saved Successfully");
            }
          });
        },
        (error) => {
          this.showSpinner = false;
          self.$toaster.error("Failed to add document");
        }
      );
    },
    submitUrl() {
      this.urlValue = this.urlValue.trim();
      if (this.urlValue.length > 0) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      this.typeUrlCheck = false;
    },
    deleteFile(index, type) {
      if (type == "add") {
        this.files.add.splice(index, 1);
        this.files.documentType.splice(index, 1);
      } else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
    },
    deleteURL(index, type) {
      if (type == "add") {
        this.url.add.splice(index, 1);
        this.documentTypeUrlAdd.splice(index, 1);
      } else {
        let data = this.url.update.splice(index, 1);
        this.url.delete.push(data[0]);
      }
    },
    async download(item) {
      let self = this;
      if (self.showDownloadDocumnets) {
        if (item.s3_path) {
          let urlData = await api
            .post(`/file/download`, {
              encrypt: {
                data: {
                  s3_path: item.s3_path,
                },
              },
            })
            .catch((e) => {
              console.error("error: ", e);
            });
          if (
            urlData &&
            urlData.data &&
            urlData.data.encrypt &&
            urlData.data.encrypt.url
          ) {
            // window.open(urlData.data.encrypt.url);
            this.downloadLink = urlData.data.encrypt.url;

            setTimeout(() => {
              self.$refs.hiddenDownloadLink.click();
            });
          }
        } else {
          this.downloadLink = item.url;
          if (this.downloadLink.length > 1) {
            if (!this.downloadLink.startsWith("https"))
              this.downloadLink = "https://" + this.downloadLink;
          }
          setTimeout(() => {
            self.$refs.hiddenDownloadLink.click();
          });
        }
      }
    },
    showAddModal() {
      if (this.context == "companyProfile") {
        this.modalData.company = this.portfolioItem._id;
        this.isCompanyDisabled = true;
        this.$store.commit("file/showAddModal", true);
        this.addProps.value = {
          isShow: true,
          isCompanyDisabled: true,
          data: {
            portfolio_item: this.portfolioItem._id,
            notes: "",
            date: "",
          },
        };
        this.addProps.portfolioItem = this.portfolioItem;
      }
      this.addFlag = true;
    },
    DocumentTypeChange(selected, context, operation) {},
    handleCancelDeleteDocument() {
      this.deleteData = {};
      this.deleteFlag = false;
      this.showDeleteSpinner = false;
    },
    handleDeleteDocument(data) {
      const self = this;
      if (data._id) {
        self.showDeleteSpinner = true;
        self.$store
          .dispatch("file/deleteDocument", data)
          .then((res) => {
            self.$store.dispatch("file/getFile").then((response) => {
              self.data.attachments = self.$store.getters[
                "file/filesByPortfloioId"
              ](self.portfolioItem._id);
              self.handleCancelDeleteDocument();
              self.$toaster.success("Deleted successfully.");
            });
          })
          .catch((error) => {
            console.log(error);
            this.$toaster.error("Failed to Delete Document..!!");
          });
      }
    },
    handleEditDocument(item) {
      this.isEdit = true;
      this.editProps = {
        data: JSON.parse(JSON.stringify(item)),
        isUpdate: true,
        context: "companyProfile",
        portfolioItem: JSON.parse(JSON.stringify(this.portfolioItem)),
      };
      if (this.$refs.editDocumentsCard) {
        this.$refs.editDocumentsCard.checkValidations();
      }
    },
    refreshDocuments() {
      const self = this;
      self.$store.dispatch("file/getFile").then((response) => {
        self.data.attachments = self.$store.getters["file/filesByPortfloioId"](
          self.portfolioItem._id
        );
        self.$toaster.success("Updated successfully.");
        self.isEdit = false;
      });
    },
    refreshAddDocuments() {
      const self = this;
      self.$store.dispatch("file/getFile").then((item) => {
        self.data.attachments = self.$store.getters["file/filesByPortfloioId"](
          self.portfolioItem._id
        );
        self.addFlag = false;
      });
    },
    shareDocument(item) {
      this.shareProps = {
        data: item,
        isShow: true,
        refreshForm: true,
      };
      this.shareFlag = true;
    },
  },
  mounted() {
    //console.log("attachments", this.data);
  },
};
</script>
<style lang="scss">
button:focus {
  outline: 1px !important;
}
.style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #e3e3e3;
  border-radius: 10px;
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px #e3e3e3;
  background-color: #e3e3e3;
}

.documentsLinkPortfolio:hover {
  text-decoration: underline;
}
</style>
